import { styled } from 'style'

const LogoWithTextStyled = styled('svg', {
  variants: {
    size: {
      sm: {
        height: 16,
      },
      md: {
        height: 20,
      },
      lg: {
        height: 26,
      },
      xl: {
        height: 34,
      },
      '2xl': {
        height: 42,
      },
    },
  },
})

export default LogoWithTextStyled
